import React, {useState, useContext, useEffect} from 'react'
import ProgressBar from '../atoms/ProgressBar'
import { getPrice, getProgressPercentPerBlock, sendDataLayer } from '../../utils/functions'
import { StateController } from './../../App'
import Preloader from '../atoms/Preloader'
import { getMaximumBlock } from '../../utils/functions'
import AwardBox from '../molecules/AwardBox'
import Button from '../atoms/Button'
import useWidth from '../../hooks/useWidth'
import CustomModal from '../molecules/CustomModal';
import MechanicModal from '../molecules/MechanicModal'
import TestQuestions from '../organisms/TestQuestions'
import CounterDown from '../atoms/CounterDown'

function Progress() {
  const {context} = useContext(StateController)
  const [awards, setAwards] = useState(false)
  const [redemtions, setRedemtions] = useState(false)
  const { width } = useWidth();
  const [showModal, setShowModal] = useState(false)
  const [showCounterDown, setShowCounterDown] = useState(false)
  const [showMechanicModal, setShowMechanicModal] = useState(false)

  useEffect(() => {
    const now = new Date();
    const startDate = new Date('2025-07-16T00:00:00');
    const endDate = new Date('2025-08-15T23:59:59');

    if (now >= startDate && now <= endDate && context && context.tracing && context.tracing.winner_1 === 1 && context.redemtions.length > 0) {
      setShowCounterDown(true);
    }
  }, [context])
    
  useEffect(() => {
    if (context && context.awards) {
      setAwards(
        (context.awards[`block_${getMaximumBlock(context.block, context.blocks)}`].awards).find(award => award.name === context.user.award_name)
      )
    }
    if (context && context.redemtions) {
      setRedemtions(context.redemtions)
    }
    if (context && context.tracing && context.tracing.winner_1 === 1 && context.redemtions.length === 0) {
      setShowModal(true)
    }
  }, [context])

  const handleMechanicModal = () => {
    sendDataLayer({datalayer: {event: "how_to_win_click", text: '¿Cómo ganar?'}, repeat: true});
    setShowMechanicModal(true)
  };

  return (
    <div className='mc-page progress slow_ani'>
      {showCounterDown && 
        <CounterDown showDays={true} showHours={true} showMins={true} showSegs={true}/>
      }
      <div className='banner'>
        <h1>
          <p className='big'>A toda</p>
          <p className='big'>compra</p>
          <div className="reward-banner">
            <span className="corner-square"></span>
            <p className='blue'>le llega su recompensa.</p>
          </div>
          <p className='small'><strong>Participa por bonos y un viaje doble todo incluido a Brasil</strong> usando tu Tarjeta de Crédito Mastercard del Banco de Bogotá.</p>
        </h1>
        <Button
          type="primary"
          text='¿Cómo ganar?'
          loading={false}
          status='active'
          onClick={handleMechanicModal}
        />
      </div>
      {context
      ? <>
          <div className='progress-container'>
            <p>{context && (context.user.calculating_amount_option === context.user.goal_amount_1) ? 'Eres calculador: planea y gana' : 'Eres imparable: suma y gana'}</p>
            <p>Tu avance:</p>
            {(context.tracing  && context.tracing[`date_update`]) &&
              <div className='actualizacion-container'>
                <p className='date'>
                  Semanalmente actualizamos las compras que ves en tu avance. Hoy aparecen las que hiciste hasta el {(context.tracing  && context.tracing[`date_update`]) ? context.tracing[`date_update`] : '' }.
                </p>
                <p className='disclaimer'>Si acabas de seleccionar tu meta y ya la cumpliste, tu bono estará habilitado en máximo 8 días. </p>
              </div>
            }
            <div className={`barInfo-container`}>
              <div className='barInfo'>
                <div className='barInfo--head'>
                  Facturación
                </div>
                <div className='barInfo--row'>
                  <span>
                    <strong>Llevas:</strong> {getPrice(context.tracing ? context.tracing[`amount_1`] : 0)}
                  </span>
                  <span>
                    <strong>Meta:</strong> {getPrice(context.user ? context.user[`goal_amount_1`] : 0)}
                  </span>
                </div>
                <ProgressBar
                  percent={getProgressPercentPerBlock(context, 'amount', 1)}
                  label={`${getProgressPercentPerBlock(context, 'amount', 1)}%`}
                  character={'/assets/images/icono_compras.svg'}
                />
              </div>
              <div className='barInfo'>
                <div className='barInfo--head'>
                  Compras
                </div>
                <div className='barInfo--row'>
                  <span>
                    <strong>Llevas:</strong> {context.tracing ? context.tracing[`trx_1`] : 0}
                  </span>
                  <span>
                    <strong>Meta:</strong> {context.user ? context.user[`goal_trx_1`] : 0}
                  </span>
                </div>
                <ProgressBar
                  percent={getProgressPercentPerBlock(context, 'trx', 1)}
                  label={`${getProgressPercentPerBlock(context, 'trx', 1)}%`}
                  character={'/assets/images/icono_trx.svg'}
                />
              </div>
            </div>
            <div className='logoBdb'>
              <img src="/assets/images/logo_bdb.png" alt="Logo BdB" />
            </div>
          </div>
          <img src='/assets/images/confeti_izq.png' className='confeti_izq' alt='confeti_izq'/>
          <div className='award-container'>
            <p className='title'>
              {context && context.tracing && (context.tracing.amount_1 >= context.user.goal_amount_1) ? '¡Cumpliste la meta! Descarga tu recompensa.' : '¡Alcanza la meta y desbloquea tu recompensa!'}       
            </p>
            <div className='cards-container' id='premio'>
              {redemtions.length > 0  ? (
                <>
                   {redemtions[0] && 
                      <div className={`mc-awards-container mc-awards-column-${1}`}>
                        <div className="mc-awards-container__items">
                          <div key={0} className={`mc-awards-container__items--item type-${3}`}>
                            <AwardBox
                              type={3}
                              award={redemtions[0]}
                              canRedem={true}
                              redemtionText={'Descarga tu bono'}
                              termText="Aplican términos y condiciones."
                              download={true}
                              position={1}
                              isDownloaded={true}
                              showStock={false}
                              twoStepAuth={false}
                              termLink="/"
                              textTitle= {context.user && context.user.goal_amount_1 === context.user.calculating_amount_option ? 'Calculador' : 'Imparable'}
                              segment= {context.user && context.user.segment ? context.user.segment : ''}
                              idmask= {context.user && context.user.idmask ? context.user.idmask : ''}
                            />
                          </div>
                        </div>
                      </div>
                  }
                    {redemtions[1] && 
                      <div className={`mc-awards-container mc-awards-column-${1}`}>
                        <div className="mc-awards-container__items">
                          <div key={0} className={`mc-awards-container__items--item type-${3}`}>
                            <AwardBox
                              type={3}
                              award={redemtions[1]}
                              canRedem={true}
                              redemtionText={'Descarga tu bono'}
                              termText="Aplican términos y condiciones."
                              download={true}
                              position={2}
                              isDownloaded={true}
                              showStock={false}
                              twoStepAuth={false}
                              termLink="/"
                              textTitle= {context.user && context.user.goal_amount_1 === context.user.calculating_amount_option ? 'Calculador' : 'Imparable'}
                              segment= {context.user && context.user.segment ? context.user.segment : ''}
                              idmask= {context.user && context.user.idmask ? context.user.idmask : ''}
                            />
                          </div>
                        </div>
                      </div>
                    }
                  </>
               ) : 
                  <div className={`mc-awards-container mc-awards-column-${1}`}>
                    <div className="mc-awards-container__items">
                      <div key={0} className={`mc-awards-container__items--item type-${3}`}>
                        <AwardBox
                          index={0}
                          type={3}
                          award={awards}
                          canRedem={false}
                          redemtionText="Avanza para desbloquear"
                          termText="Aplican términos y condiciones."
                          showStock={false}
                          twoStepAuth={false}
                          termLink="/"
                        />
                      </div>
                    </div>
                  </div>
                  
              }
              <div className={`mc-awards-container mc-awards-column-${1}`}>
                <div className="mc-awards-container__items">
                  <div key={0} className={`mc-awards-container__items--item type-${2}`}>
                    <p className='title-piñata'>¡Rómpela!</p>
                    <img
                      src={
                        '/assets/images/bolsa_10.png'
                      }
                      alt='bolsa'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cards-container-with-lines">
            <img src="/assets/images/tarjetas.png" alt="tarjetasBogota"/>
          </div>
          <div className='images-container'>
            <div className='benefits'>
              <div className='benefits-text-container'>
                {width > 992
                ? <p>
                    Conoce todos los descuentos de tus tarjetas Mastercard y sácale provecho a tus compras.
                  </p>
                : <p>
                    Conoce todos los descuentos<br/>de tus tarjetas Mastercard<br/>y sácale provecho a tus compras.
                  </p>
                }
                
                <Button
                  type="primary"
                  text='Conoce los beneficios'
                  loading={false}
                  status='active'
                  external={true}
                  link='https://www.mastercard.com.co/es-co/consumidores/conozca-nuestras-ofertas-y-promociones/every-day-value.html'
                  datalayer={{event: 'mastercard_benefits', link: 'https://www.mastercard.com.co/es-co/consumidores/conozca-nuestras-ofertas-y-promociones/every-day-value.html'}}
                />
              </div>
            </div>
            <div className='award-info'>
              <p>¡Suma compras y participa por un viaje a Brasil!</p>
              <div className="reward-banner">
                <span className="corner-square"></span>
                {width > 992 
                ? <p className='blue'>Cumple tu meta<br/>y podrás ganar un viaje todo incluido para dos <br/>a Rio de Janeiro.</p>
                : <p className='blue'>Cumple tu meta y podrás ganar un viaje todo incluido para dos a Rio de Janeiro.</p>
                }
                
              </div>
            </div>
          </div>
          { context && context.quiz && (context.quiz.length === 0 || context.quiz.every(q => q.response_1 === null)) &&
            <div className='mc-section-testForm'>
              <TestQuestions context={context} quizNumber={1} />
            </div>
          }
          <img src='/assets/images/confeti_der.png' className='confeti_der' alt='confeti_der'/>
      </> 
      : <Preloader
          type="section"
          invert
        />
      }
      {showModal && (
        <CustomModal
          title={`¡La recompensa es tuya!`}
          desc={
              "Tu bono está en camino. En máximo 8 días estará listo para que lo disfrutes."
          }
          image="piñata_modal.png"
          show={showModal}
          setShowModal={setShowModal}
          cta="Vuelve pronto"
        />
      )}
      {showMechanicModal && (
        <MechanicModal
          title={`¡La recompensa es tuya!`}
          desc={
              "Tu bono está en camino. En máximo 15 días estará listo para que lo disfrutes."
          }
          image="piñata_modal.png"
          show={showMechanicModal}
          setShowModal={setShowMechanicModal}
          cta="Vuelve pronto"
        />
      )}
    </div>
  )
}
export default Progress